import React from 'react';

function BookingWidget() {
  return (
    <div className="booking-widget">
      <div className="booking-header">
        <h3>
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" 
              fill="currentColor"
            />
          </svg>
          Termin vereinbaren
        </h3>
        <p>Wählen Sie direkt einen passenden Termin aus</p>
      </div>

      <div className="booking-content">
        <div className="booking-benefits">
          <h4>Was Sie erwartet:</h4>
          <ul>
            <li>✅ Kostenlose Erstberatung</li>
            <li>✅ Unverbindliche Bedarfsanalyse</li>
            <li>✅ Konkrete Handlungsempfehlungen</li>
            <li>✅ Transparente Kosteneinschätzung</li>
          </ul>
        </div>

        <div className="booking-calendar">
          <iframe 
            src="https://calendar.google.com/calendar/appointments/AcZssZ35_OtooSbxjmF619pzZjo8HAM7IsV6Dl9aR-M=?gv=true" 
            style={{ border: 0 }} 
            width="100%" 
            height="600" 
            frameBorder="0"
            title="Terminbuchung"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default BookingWidget;
